<template>
    <div>
        <b-table small head-variant="dark" hover :items="dados" :fields="colunas"></b-table>
    </div>
</template>
<script>
import DashboardAdminService from "@/common/services/dashboards/dashboard_admin.service";
import helpers from "@/common/utils/helpers";
export default {
    data : () => ({
        dados : [],
        colunas:[
            {
                key: "empresa",
                label: "Empresa proponente",
            },
            {
                key: "segmento",
                label: "Segmento",
            },
            {
                key: "regiao",
                label: "Região",
            },
            {
                key: "saldo",
                label: "Saldo à investir",
                formatter : (valor) => {
                    if(valor)
                    return helpers.formatarValor(valor);
                }
            },
        ],
    }),
    methods : {
        buscar : function(){
            DashboardAdminService.saldoAInvestir().then(response => {
                this.dados = response.data.data;
            })
        }
    },
    mounted(){
        this.buscar();
    },
}
</script>
<style lang="">
    
</style>